<template>
  <div class="kt-grid kt-grid--hor kt-grid--root">
    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
      <div id="kt_wrapper" class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
        <div id="kt_header" class="kt-header kt-grid__item  kt-header--fixed " data-ktheader-minimize="on" kt-hidden-height="70" style="">
          <HeaderTopbar />
        </div>

        <div id="kt_body" class="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch">
          <div v-if="isTokenDebugger">
            <router-view />
          </div>
          <div v-else class="kt-container  kt-container--fluid  kt-grid kt-grid--ver" style="height: 100%">
            <button id="kt_aside_close_btn" class="kt-aside-close ">
              <i class="la la-close" />
            </button>
            <AsideMenu />
            <router-view />
          </div>
        </div>
        <div v-if="!isTokenDebugger" id="kt_footer" class="kt-footer kt-grid__item">
          <Footer />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HeaderTopbar from './layout/HeaderTopbar'
import AsideMenu from './layout/AsideMenu'
import Footer from './layout/Footer'

export default {
  name: 'App',
  components: {
    HeaderTopbar,
    AsideMenu,
    Footer
  },
  data () {
    return {
      refreshTokenInterval: false
    }
  },
  computed: {
    isTokenDebugger () {
      return this.$route.name && this.$route.name === 'tokendebugger'
    }
  },
  mounted () {
    if (!this.isTokenDebugger) {
      this.checkExpireToken()
      this.setupRefreshToken()
    }
  },
  beforeDestroy () {
    this.clearRefreshTokenInterval()
  },
  methods: {
    ...mapGetters({
      getUserDetail: 'user/getUserDetail',
      allProject: 'project/getAllProject'
    }),
    ...mapActions({
      refreshToken: 'user/refresh'
    }),
    clearRefreshTokenInterval () {
      if (this.refreshTokenInterval) {
        clearInterval(this.refreshTokenInterval)
        this.refreshTokenInterval = false
      }
    },
    checkExpireToken () {
      const userDetail = this.getUserDetail()
      if (userDetail) {
        const expireDate = new Date(userDetail.authTokenExpireAt).getTime()
        const durationToExpireMillisec = expireDate - Date.now()
        if (durationToExpireMillisec <= 0) {
          this.$router.push('/login')
        } else {
          console.log(`${Math.round(durationToExpireMillisec / 1000 / 60)} minutes to expire.`)
        }
      } else {
        this.$router.push('/login')
      }
    },
    setupRefreshToken () {
      this.refreshTokenInterval = setInterval(async () => {
        const userDetail = this.getUserDetail()
        if (userDetail) {
          if (userDetail.authToken && userDetail.authTokenExpireAt) {
            let expireAt = userDetail.authTokenExpireAt
            expireAt = new Date(expireAt).getTime()
            if (expireAt - Date.now() < 10 * 60 * 1000) {
              // 10 minutes to expires
              this.refreshToken()
              console.log('Token has been refreshed')
            }
          } else {
            this.clearRefreshTokenInterval()
          }
        } else {

        }
      }, 1 * 60 * 1000)
    }
  }
}
</script>
